import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {PanelOptionInterface} from '@shared/interface';

@Component({
  selector: 'mkad-panel-grid-control',
  standalone: true,
  imports: [],
  templateUrl: './panel-grid-control.component.html',
  styleUrl: './panel-grid-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelGridControlComponent {
  readonly dataList = input<PanelOptionInterface[]>([]);
}
